// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

// Default Content
export const StyledContent = styled(Content) `
  margin: 24px 16px;
`

// Chart Card (no border)
export const ChartCard = styled(Card) `
  .ant-card-head {
    border: 0;
  }
  .ant-card-body {
    padding: 0 !important;
  }
  .sticky-outer-wrapper.active {
    .sticky-inner-wrapper {
       z-index: 999;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/mixins.js